export const CHALLAN_REQUEST = "CHALLAN_REQUEST";
export const CHALLAN_SUCCESS = "CHALLAN_SUCCESS";
export const CHALLAN_FAILED = "CHALLAN_FAILED";